import Entity from "./entity";

export default class Link extends Entity<number> {
  id: number;
  name:string;
  url:string;
  target:string;
  external:boolean;
  order:number;
  tenantId:number;
  type:number;
}
